import XySelect from './xy-select';

import { getWormholeList } from './service';
import { Singleton } from './utils/decorator';
import { formatWormholeList } from './utils';

export type PortalOptions = {
  // 入口名称
  portalName: string;
  ulpOrigin: string;
  // 入口样式
  style?: Partial<CSSStyleDeclaration>;
  // 访问的首页地址
  homePagePath?: string;
  // 禁用下拉框政策
  disableUrlRegexp?: RegExp | string;
};

function isDisabled(disableUrlRegexp: string | RegExp) {
  if (!disableUrlRegexp) return false;
  const regexp = new RegExp(disableUrlRegexp);
  return regexp.test(window.location.href);
}

@Singleton
export class PortalSelect {
  private options!: PortalOptions;

  private loadSelect = false;

  private select!: XySelect;

  // eslint-disable-next-line no-use-before-define
  private static instance: PortalSelect;

  constructor(options: PortalOptions) {
    this.options = options;
    window.addEventListener('hashchange', () => {
      this.onUrlChange();
    });
  }

  onUrlChange() {
    const { disableUrlRegexp } = this.options ?? {};
    if (disableUrlRegexp) {
      const regexp = new RegExp(disableUrlRegexp);
      if (regexp.test(window.location.href)) {
        this.select.disableSelect();
      } else {
        this.select.enableSelect();
      }
    }
  }

  renderSelect = async () => {
    if (this.loadSelect) return;

    const { options } = this;
    if (!options) return;

    const { portalName, style, ulpOrigin, homePagePath } = options;
    this.loadSelect = true;

    const list = await getWormholeList(ulpOrigin, portalName);
    if (list.length === 0) return;

    const wormholeList = formatWormholeList(list, homePagePath);
    const disabled = isDisabled(options.disableUrlRegexp ?? '');

    const select = new XySelect(
      style,
      wormholeList,
      window.location.origin,
      value => {
        window.location.href = value;
      },
      disabled,
    );
    this.select = select;
    select.renderSelect();
  };

  public static getSelect(config: PortalOptions) {
    if (!PortalSelect.instance) {
      PortalSelect.instance = new PortalSelect(config);
    }
    return PortalSelect.instance;
  }
}
